"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ChevronRightSolid_1 = __importDefault(require("../../../IconsNavigation/ChevronRightSolid"));
const InputLabel_1 = __importDefault(require("../InputLabel"));
const store_1 = require("../../context/store");
const styled_1 = require("../../styled");
const styled_2 = require("./styled");
const CryptoList_1 = __importDefault(require("../CryptoList"));
const CoinWrapper_1 = __importDefault(require("../CoinWrapper/CoinWrapper"));
const CryptoSelect = () => {
    const { selectedCrypto, lockCrypto } = (0, store_1.useTrackedState)();
    const [show, setShow] = (0, react_1.useState)(false);
    const coinList = [
        {
            src: "/coins/eth.png",
            alt: "ETH",
        },
        {
            src: "/coins/matic.png",
            alt: "MATIC",
        },
    ];
    return (react_1.default.createElement(styled_1.Field, { style: { minWidth: 200 } },
        react_1.default.createElement(InputLabel_1.default, null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.crypto-title" })),
        react_1.default.createElement(styled_2.SelectWrapper, { onClick: () => {
                if (lockCrypto)
                    return;
                setShow(true);
            } },
            react_1.default.createElement("img", { src: selectedCrypto.image, alt: selectedCrypto.code, height: 22, width: 22, loading: "lazy" }),
            react_1.default.createElement(styled_2.CoinText, null,
                selectedCrypto.label,
                react_1.default.createElement(styled_2.SubText, null,
                    "(",
                    selectedCrypto.code,
                    ")"),
                selectedCrypto.code === 'VERSE' && (react_1.default.createElement(styled_2.CoinSection, null,
                    react_1.default.createElement(CoinWrapper_1.default, { coinList: coinList })))),
            !lockCrypto && react_1.default.createElement(ChevronRightSolid_1.default, { size: 10, color: "#0085FF" })),
        react_1.default.createElement(CryptoList_1.default, { show: show, setShow: setShow })));
};
exports.default = CryptoSelect;
//# sourceMappingURL=CryptoSelect.js.map